import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import HeroSection from '../../components/home/HeroSection';
import HomeProductSection from '../../components/home/HomeProductSection';

const HomePage = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />
            <main className="flex-grow">
                <HeroSection />
                <HomeProductSection />
            </main>
            <Footer />
        </div>
    );
};

export default HomePage;